import axios from 'axios';
import Vue from 'vue';
import { Dropdown, DropdownMenuItem, SInput, SButton, Icon, Modal } from '@sas-te/alfabeto-vue';
import { mapState, mapActions, mapMutations } from 'vuex';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// TODO: change to portalsaseducacao.com.br after domain migration
const defaultDomain = 'portalsas.com.br';
const portalDomains = ['portalsas.com.br', 'portalsaseducacao.com.br'];
const trustedDomains = [...portalDomains, 'saseducacao.com.br', 'sasdigital.com.br'];
Object.freeze(portalDomains);
Object.freeze(trustedDomains);
const getPortalDomain = () => {
  try {
    const HOSTNAME_PARTS_LENGTH = 3;
    const hostnameParts = window.location.hostname.split('.');

    if (hostnameParts.length < HOSTNAME_PARTS_LENGTH) {
      return defaultDomain;
    }

    const domain = hostnameParts.slice(-HOSTNAME_PARTS_LENGTH).join('.');

    if (!portalDomains.includes(domain)) {
      return defaultDomain;
    }

    return domain;
  } catch (error) {
    return defaultDomain;
  }
};
const portalDomain = getPortalDomain();
const getCookieDomain = env => {
  if (env === 'development') {
    return 'localhost';
  }

  return portalDomain;
};

const A_DAY_IN_SECONDS = 86400;
let cookieDomain = 'localhost';
const setCookieDomain = env => {
  cookieDomain = getCookieDomain(env);
};
const setCookie = (name, value, options = {}) => {
  if (typeof document === 'undefined') {
    return;
  }

  const mergedOptions = _objectSpread2({
    path: '/',
    domain: cookieDomain,
    SameSite: 'Strict Secure' ,
    'max-age': A_DAY_IN_SECONDS
  }, options);

  if (mergedOptions.expires instanceof Date) {
    mergedOptions.expires = mergedOptions.expires.toUTCString();
  }

  let cookieWithOptions = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  Object.keys(mergedOptions).forEach(optionKey => {
    const optionValue = mergedOptions[optionKey];
    cookieWithOptions += `; ${optionKey}`;

    if (optionValue !== true) {
      cookieWithOptions += `=${optionValue}`;
    }
  });
  document.cookie = cookieWithOptions;
};
const getCookie = name => {
  if (typeof document === 'undefined' || !name) {
    return null;
  }

  const cookieName = `${name}=`;
  const decodedCookies = decodeURIComponent(document.cookie);
  const cookies = decodedCookies.split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    let cookie = cookies[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }

  return null;
};
const deleteCookie = (name, options) => {
  setCookie(name, '', _objectSpread2(_objectSpread2({}, options), {}, {
    expires: -1
  }));
};

const tokenCookieName = 'token';
const refreshTokenCookieName = 'refreshToken';
const sessionCookieName = 'session';
let portalURL;
let authServerAPI;
const setupAuth = options => {
  portalURL = options.portalURL;
  authServerAPI = options.authServerAPI;
};
const getAuthToken = () => getCookie(tokenCookieName);
const getAuthSession = () => getCookie(sessionCookieName);
const getRefreshToken = () => getCookie(refreshTokenCookieName);
const hasRefreshToken = () => !!getRefreshToken();
const setAuthCookies = ({
  token,
  refreshToken,
  sessionToken
}) => {
  const THIRTY_DAYS_IN_SECONDS = 2592000;
  const bearerToken = token.startsWith('Bearer') ? token : `Bearer ${token}`;
  setCookie(tokenCookieName, bearerToken);
  setCookie('strategy', 'token');
  setCookie(sessionCookieName, sessionToken);
  setCookie(refreshTokenCookieName, refreshToken, {
    'max-age': THIRTY_DAYS_IN_SECONDS
  });
};
const clearAuthTokens = () => {
  deleteCookie(tokenCookieName);
  deleteCookie('strategy');
  deleteCookie(sessionCookieName);
  deleteCookie(refreshTokenCookieName);
};
const logout = ({
  redirectBack
} = {
  redirectBack: true
}) => {
  const redirectToLogin = () => {
    const {
      href
    } = window.location;
    const normalizedURL = (href.endsWith('/') ? href.substr(0, href.length - 1) : href).split('?')[0];
    let params = '';

    if (redirectBack && normalizedURL !== portalURL && normalizedURL !== `${portalURL}/login`) {
      params += `?redirect=${encodeURIComponent(href)}`;
    }

    window.location.assign(`${portalURL}${params}`);
  };

  clearAuthTokens();
  redirectToLogin();
};
const refreshAuthTokens = (() => {
  let refreshTokenPromise = null;
  return async () => {
    // Prevent refreshToken to be called multiple times
    if (refreshTokenPromise instanceof Promise) {
      return refreshTokenPromise;
    }

    refreshTokenPromise = axios.post(`${authServerAPI}/v2/auth/refreshToken`, {
      token: getRefreshToken()
    });
    const response = await refreshTokenPromise;
    setAuthCookies(response.data.authResponse); // clear promise

    refreshTokenPromise = null;
    return Promise.resolve(response);
  };
})();

/* eslint-disable import/prefer-default-export */
const hasOwnProperty = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

const staging = {
  portalURL: `https://portal.staging.${portalDomain}`,
  authServerAPI: `https://auth-server.staging.${portalDomain}`,
  publicFilesURL: `https://public.staging.${portalDomain}`,
  apiURL: `https://api.staging.${portalDomain}`,
  portalAPI: 'https://portal-api.staging.sasdigital.com.br',
  storageAPI: 'https://storage-service.staging.sasdigital.com.br',
  authDomain: portalDomain
};
const development = _objectSpread2(_objectSpread2({}, staging), {}, {
  portalURL: 'http://localhost:8080',
  authDomain: 'localhost'
});
const production = {
  portalURL: `https://${portalDomain}`,
  authServerAPI: `https://auth-server.${portalDomain}`,
  publicFilesURL: `https://public.${portalDomain}`,
  apiURL: 'https://api.sasdigital.com.br',
  portalAPI: 'https://portal-api.sasdigital.com.br',
  storageAPI: 'https://storage-service.sasdigital.com.br',
  authDomain: portalDomain
};
var urls = {
  staging,
  development,
  production
};

const httpCodes = {
  ok: 200,
  created: 201,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  notAcceptable: 406,
  conflict: 409,
  unsuportedMediaType: 415,
  unprocessableEntity: 422,
  tooManyRequests: 429,
  internalServerError: 500,
  serviceUnavailable: 503,
  gatewayTimeout: 504
};
var httpCodes$1 = Object.freeze(httpCodes);

function addAuthorizationHeader(config) {
  const requestConfig = _objectSpread2({}, config);

  requestConfig.headers.Authorization = getAuthToken();
  return requestConfig;
}

async function handleRequestInterceptorError(error) {
  const handleRedirection = status => {
    const errorsWithPages = [httpCodes$1.serviceUnavailable, // those errors shouldn't exist as pages
    httpCodes$1.internalServerError, httpCodes$1.forbidden];

    if (status === httpCodes$1.unauthorized) {
      logout();
    } else if (errorsWithPages.includes(status)) {
      window.location.assign(`${Vue.$_menu_env.portalURL}/error/${status}`);
    }
  };

  if (error.response.status === httpCodes$1.unauthorized && hasRefreshToken()) {
    try {
      await refreshAuthTokens();
      return axios(addAuthorizationHeader(error.config));
    } catch (newError) {
      handleRedirection(newError.response.status);
    }
  } else {
    handleRedirection(error.response.status);
  }

  return Promise.reject(error);
}

const api = axios.create();
api.interceptors.request.use(addAuthorizationHeader);
api.interceptors.response.use(response => response, handleRequestInterceptorError);

const SET_MENUS = 'SET_MENUS';
const SET_SPECIFIC_MENU = 'SET_SPECIFIC_MENU';

var actions$1 = {
  async getMenus({
    commit
  }) {
    const config = {
      baseURL: Vue.$_menu_env.portalAPI
    };
    const {
      data
    } = await api.get('usermenu', config);
    commit(SET_MENUS, data);
  },

  async getSpecificMenu({
    commit
  }) {
    const config = {
      baseURL: Vue.$_menu_env.portalAPI
    };
    const {
      data
    } = await api.get('sidemenu', config);
    commit(SET_SPECIFIC_MENU, data.subItems);
  }

};

var mutations$2 = {
  [SET_MENUS](state, menus) {
    state.menus = menus;
  },

  [SET_SPECIFIC_MENU](state, specificMenu = []) {
    state.specificMenu = specificMenu;
  }

};

const state$2 = () => ({
  menus: [],
  specificMenu: []
});

var menuModule = {
  namespaced: true,
  state: state$2,
  actions: actions$1,
  mutations: mutations$2
};

const SET_PROFILE = 'SET_PROFILE';
const SET_PROFILE_MODAL = 'SET_PROFILE_MODAL';
const SET_PERSONAL_DATA = 'SET_PERSONAL_DATA';

var actions = {
  async getProfiles({
    commit
  }) {
    const config = {
      baseURL: Vue.$_menu_env.authServerAPI
    };
    const {
      data
    } = await api.get('v2/users/me/profiles', config);
    commit(SET_PROFILE, data);
  },

  toggleProfileModal({
    commit
  }, value) {
    commit(SET_PROFILE_MODAL, value);
  },

  async getPersonalData({
    commit
  }) {
    const config = {
      baseURL: Vue.$_menu_env.authServerAPI
    };
    const {
      data
    } = await api.get('v2/personal-data', config);
    commit(SET_PERSONAL_DATA, data);
  }

};

var mutations$1 = {
  [SET_PROFILE](state, currentProfile) {
    state.currentProfile = currentProfile;
  },

  [SET_PROFILE_MODAL](state, openProfileModal) {
    state.openProfileModal = openProfileModal;
  },

  [SET_PERSONAL_DATA](state, personalData = {}) {
    state.personalData = personalData;
  }

};

const state$1 = () => ({
  currentProfile: {
    name: ''
  },
  openProfileModal: false,
  personalData: {}
});

var profileModule = {
  namespaced: true,
  state: state$1,
  actions,
  mutations: mutations$1
};

var mutations = {
  setTypeformReady(state, payload) {
    state.isTypeformReady = payload;
  }

};

const state = {
  isTypeformReady: false
};
var typeformModule = {
  namespaced: true,
  state,
  mutations
};

const removeDiacritics = text => {
  if (!text) {
    return '';
  }

  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

//
var script$7 = {
  name: 'SAutocomple',
  components: {
    Dropdown,
    DropdownMenuItem,
    SInput
  },
  model: {
    event: 'select'
  },
  props: {
    title: {
      type: String,
      default: 'Selecione'
    },
    placeholder: {
      type: String,
      default: 'Pesquisar por nome ou código'
    },
    value: {
      type: null,
      default: null
    },
    propDisplay: {
      type: String,
      default: 'value'
    },
    propValue: {
      type: String,
      default: 'id'
    },
    options: {
      type: Array,
      required: true
    },
    widthBoxMenu: {
      type: String,
      default: '100%'
    },
    sizeDropdown: {
      type: String,
      default: 'medium',
      validator: value => value.match(/(small|medium|large)/)
    },

    /**
     * Size of the icon
     * `small, medium, large`
     */
    sizeFilter: {
      type: String,
      default: 'medium',
      validator: value => value.match(/(small|medium|large)/)
    },
    trackBy: {
      type: String,
      default: null
    },
    noOverflow: Boolean,
    status: {
      type: String,
      default: null
    }
  },
  data: () => ({
    active: false,
    search: ''
  }),
  computed: {
    normalizedOptions() {
      return this.options.map(option => ({
        [this.propDisplay]: removeDiacritics(option[this.propDisplay]).toLowerCase(),
        [this.propValue]: removeDiacritics(option[this.propValue]).toLowerCase()
      }));
    },

    filteredOptions() {
      if (!this.search) {
        return this.options;
      }

      const query = removeDiacritics(this.search).toLowerCase();
      return this.options.filter((_, index) => {
        const option = this.normalizedOptions[index];
        return option[this.propDisplay].includes(query) || option[this.propValue].includes(query);
      });
    },

    formattedValue() {
      if (!this.value) {
        return '';
      }

      return this.trackBy ? this.value[this.trackBy] : this.value;
    }

  },
  methods: {
    toggle(value) {
      this.active = value;
    },

    close() {
      this.active = false;
      this.search = '';
    },

    select(option) {
      this.$emit('select', this.isSelected(option) ? null : option);
      this.close();
    },

    isSelected(option) {
      return this.value === option[this.propValue];
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sas-autocomplete"
  }, [_c('Dropdown', {
    class: (_obj = {}, _obj["--" + _vm.status] = _vm.status, _obj),
    attrs: {
      "menu-width": _vm.widthBoxMenu,
      "open": _vm.active,
      "size": _vm.sizeDropdown,
      "text": _vm.formattedValue || _vm.title,
      "width": "100%"
    },
    on: {
      "toggle": function toggle($event) {
        return _vm.toggle($event);
      }
    }
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('SInput', {
    staticClass: "s-filter-autocomplete",
    attrs: {
      "icon-left": "search",
      "placeholder": _vm.placeholder,
      "size": _vm.sizeFilter
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c('div', {
    class: ['content-list', {
      overflow: !_vm.noOverflow
    }]
  }, _vm._l(_vm.filteredOptions, function (option, index) {
    return _c('DropdownMenuItem', {
      key: index,
      class: ['s-dropdown-menu-item', {
        '--selected': _vm.isSelected(option)
      }],
      on: {
        "click": function click($event) {
          return _vm.select(option);
        }
      }
    }, [_c('div', {
      staticClass: "prop-display",
      domProps: {
        "textContent": _vm._s(option[_vm.propDisplay])
      }
    }), _c('div', {
      staticClass: "prop-value",
      domProps: {
        "textContent": _vm._s(option[_vm.propValue])
      }
    })]);
  }), 1)])], 1);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e44eec60_0", {
    source: ".sas-dropdown-menu.sas-box[data-v-e44eec60]{min-width:inherit}.sas-dropdown[data-v-e44eec60]{position:relative!important;width:100%;margin-bottom:16px}.sas-dropdown.--error .sas-button.sas-dropdown__button[data-v-e44eec60]{box-shadow:0 0 0 2px #eb0000!important}.filter[data-v-e44eec60]{width:100%;border-bottom:1px solid #f7f7f7}.filter .s-filter-autocomplete[data-v-e44eec60]{width:100%;padding:8px 12px 0 12px;margin:8px 0}.filter .s-filter-autocomplete .sas-input__field[data-v-e44eec60]{background:#fff}.filter .s-filter-autocomplete .sas-input__icon[data-v-e44eec60]{left:10px!important}.content-list[data-v-e44eec60]{z-index:1000;display:flex;flex-direction:column;width:100%}.content-list.overflow[data-v-e44eec60]{max-height:180px;overflow-y:auto}.content-list .s-dropdown-menu-item[data-v-e44eec60]{flex-shrink:0}.prop-display[data-v-e44eec60]{display:block;display:flex;align-items:center;font-size:1rem;color:#1e2124;letter-spacing:.3px}.prop-value[data-v-e44eec60]{font-size:.875rem;color:#666e75}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$7 = "data-v-e44eec60";
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

//
var script$6 = {
  name: 'ToggleMenu',
  components: {
    SButton
  },
  data: () => ({
    isActive: false
  }),
  methods: {
    toogle() {
      this.isActive = !this.isActive;
      this.$emit('toggle', this.isActive);
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('SButton', {
    class: [_vm.$style.toggleButton, (_obj = {}, _obj[_vm.$style.active] = _vm.isActive, _obj)],
    attrs: {
      "variation": "tertiary"
    },
    on: {
      "click": function click($event) {
        return _vm.toogle();
      }
    }
  }, [_c('span', {
    class: _vm.$style.bar
  }), _c('span', {
    class: _vm.$style.bar
  }), _c('span', {
    class: _vm.$style.bar
  }), _c('span', {
    class: _vm.$style.bar
  })]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-4b9ee7b6_0", {
    source: ".src-lib-components-toggleButton-321-{position:fixed;top:26px;right:0;width:23px;height:20px;margin:3px 16px 0 30px;cursor:pointer;transition:.5s ease-in-out;transform:rotate(0)}.src-lib-components-toggleButton-321-:hover{background-color:transparent!important}.src-lib-components-toggleButton-321-.\\--tertiary:focus{box-shadow:none!important}@media (min-width:1200px){.src-lib-components-toggleButton-321-{display:none}}.src-lib-components-bar-1hgH{position:absolute;left:0;display:block;width:100%;height:2px;background:#1e2124;border-radius:8px;transition:.25s ease-in-out;transform:rotate(0)}.src-lib-components-bar-1hgH:nth-child(1){top:0}.src-lib-components-bar-1hgH:nth-child(2),.src-lib-components-bar-1hgH:nth-child(3){top:7px}.src-lib-components-bar-1hgH:nth-child(4){top:14px}.src-lib-components-active-3P-F .src-lib-components-bar-1hgH:nth-child(1){top:18px;left:50%;width:0%}.src-lib-components-active-3P-F .src-lib-components-bar-1hgH:nth-child(2){transform:rotate(45deg)}.src-lib-components-active-3P-F .src-lib-components-bar-1hgH:nth-child(3){transform:rotate(-45deg)}.src-lib-components-active-3P-F .src-lib-components-bar-1hgH:nth-child(4){top:18px;left:50%;width:0%}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "toggleButton": "src-lib-components-toggleButton-321-",
      "bar": "src-lib-components-bar-1hgH",
      "active": "src-lib-components-active-3P-F"
    }
  });
};
/* scoped */


const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

/**
 * A module that exports methods for integration with Typeform.
 * @module typeform
 *
 * For further documentation:
 * [Embed SDK]{@link https://developer.typeform.com/embed/}
 * [NPM Page]{@link https://www.npmjs.com/package/@typeform/embed}
 */
const BASE_URL = 'https://pesquisasas.typeform.com/to';
/**
 * Transforms an object into URL params.
 *
 * @param {object} params - Object to be transformed.
 */

const stringifyHiddenFields = params => new URLSearchParams(params);

var typeform = {
  /**
   * Appends Typeform Embed script into the index.html body,
   * creating the global window.typeformEmbed object attribute.
   * Only needs to be called once, ideally on the project root file.
   *
   * @param {object} onReady - Callback after the CDN is installed.
   */
  install({
    onReady,
    id = 'typeform-embed'
  }) {
    const hasScriptLoaded = !!document.getElementById(id);

    if (hasScriptLoaded) {
      if (typeof onReady === 'function') {
        onReady();
      }

      return;
    }

    const typeform = document.createElement('script');

    if (typeof onReady === 'function') {
      typeform.addEventListener('load', onReady);
    }

    typeform.setAttribute('id', id);
    typeform.setAttribute('src', 'https://embed.typeform.com/embed.js');
    document.body.appendChild(typeform);
  },

  /**
   * Creates a Typeform widget with a DOM element as container.
   *
   * @param {node} container - Container element reference.
   * @param {string} formId - Form identifier, e.g: p4EzLacv.
   * @param {object} hiddenFields - User related data, e.g: id, name.
   * @param {object} options - Form layout and behavior configurations.
   *
   * For details on the options object properties, check @typeform/embed docs.
   *
   * @example
   * const container = document.getElementById('typeform-widget-container')
   * typeform.createWidget(container, 'p4EzLacv')
   *
   * @returns {object} Typeform Embed form instance.
   */
  createWidget({
    container,
    formId,
    hiddenFields,
    options
  }) {
    const url = `${BASE_URL}/${formId}?${stringifyHiddenFields(hiddenFields)}`;
    return window.typeformEmbed.makeWidget(container, url, _objectSpread2({}, options));
  },

  /**
   * Creates a Typeform popup with no need of a DOM element container.
   *
   * @param {string} formId - Form identifier, e.g: p4EzLacv.
   * @param {object} hiddenFields - User related data, e.g: id, name.
   * @param {object} options - Form layout and behavior configurations.
   *
   * For details on the options object properties, check @typeform/embed docs.
   *
   * @example
   * const popup = typeform.createPopup('p4EzLacv')
   * popup.open()
   * popup.close()
   *
   * @returns {object} Typeform Embed form instance.
   */
  createPopup({
    formId,
    hiddenFields,
    options
  }) {
    const url = `${BASE_URL}/${formId}?${stringifyHiddenFields(hiddenFields)}`;
    return window.typeformEmbed.makePopup(url, _objectSpread2({}, options));
  }

};

const profilesTypes = {
  admin: 1,
  student: 2,
  teacher: 3,
  consultant: 5,
  guardian: 6,
  school: 7,
  helpdesk: 10,
  financialManager: 11,
  contentAdmin: 12,
  content: 14,
  orderStore: 16,
  coordinator: 17,
  schoolAdministration: 18,
  opcom: 19,
  educational: 20,
  provider: 22,
  manager: 23,
  sasProduction: 24,
  integration: 100
};
var profilesTypes$1 = Object.freeze(profilesTypes);

function getProfileTypeIcon(profileId) {
  const DEFAULT_ICON = 'admin.svg';
  const icons = {
    [profilesTypes$1.student]: 'student.svg',
    [profilesTypes$1.teacher]: 'teacher.svg',
    [profilesTypes$1.consultant]: 'consultant.svg',
    [profilesTypes$1.guardian]: 'guardian.svg',
    [profilesTypes$1.school]: 'school.svg',
    [profilesTypes$1.helpdesk]: 'helpdesk.svg',
    [profilesTypes$1.financialManager]: 'financial-manager.svg',
    [profilesTypes$1.contentAdmin]: 'content-admin.svg',
    [profilesTypes$1.orderStore]: 'order-store.svg',
    [profilesTypes$1.coordinator]: 'coordinator.svg'
  };
  const iconName = icons[profileId] || DEFAULT_ICON;
  return `https://${portalDomain}/img/profiles/${iconName}`;
}

//
var script$5 = {
  name: 'SelectedIcon',
  components: {
    Icon
  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    class: _vm.$style.selected
  }, [_c('Icon', {
    attrs: {
      "size": "10px",
      "stroke": _vm.$tokens.color_white,
      "stroke-width": "5px",
      "type": "check"
    }
  })], 1);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-d0b11260_0", {
    source: ".src-lib-components-selected-1Ef3{position:absolute;top:10px;right:10px;display:flex;align-items:center;justify-content:center;padding:4px;background:#0467db;border-radius:50%}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "selected": "src-lib-components-selected-1Ef3"
    }
  });
};
/* scoped */


const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

//
var script$4 = {
  name: 'SProfileCard',
  components: {
    SelectedIcon: __vue_component__$5
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    selected: Boolean,
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    profileTypeImage: ''
  }),
  watch: {
    id: {
      immediate: true,

      handler() {
        this.profileTypeImage = getProfileTypeIcon(this.id);
      }

    }
  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['profile-card', {
      'profile-card--selected': _vm.selected
    }],
    attrs: {
      "role": "button",
      "tabindex": _vm.tabIndex
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      },
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
          return null;
        }

        return _vm.$emit('click');
      }
    }
  }, [_c('SelectedIcon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selected,
      expression: "selected"
    }]
  }), _c('div', {
    staticClass: "profile-card__img-container"
  }, [_c('img', {
    staticClass: "profile-card__img",
    attrs: {
      "src": _vm.profileTypeImage
    }
  })]), _c('div', {
    staticClass: "profile-card__title-container"
  }, [_c('span', {
    staticClass: "profile-card__title"
  }, [_vm._v(_vm._s(_vm.name))])])], 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e895ccc8_0", {
    source: ".profile-card[data-v-e895ccc8]{position:relative;display:flex;flex-direction:column;justify-content:flex-start;width:99px;min-height:94px;text-align:center;cursor:pointer;border-radius:20px;outline:0;box-shadow:0 1px 2px rgba(52,60,88,.4);background-position:top center;background-color:#fff;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml;base64, PHN2ZyB3aWR0aD0iOTkiIGhlaWdodD0iNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggb3BhY2l0eT0iLjMiIGQ9Ik05OSA0Mi41QzY5LjUgNTQgMzIuMjQgNjAgMCA2MFY0MEMwIDIxLjE0NCAwIDExLjcxNiA1Ljg1OCA1Ljg1OCAxMS43MTYgMCAyMS4xNDQgMCA0MCAwaDE5YzE4Ljg1NiAwIDI4LjI4NCAwIDM0LjE0MiA1Ljg1OEM5OSAxMS43MTYgOTkgMjEuMTQ0IDk5IDQwdjIuNXoiIGZpbGw9IiNDMEQ5RjYiLz48L3N2Zz4=\");transition:all .2s ease-in-out}.profile-card__img-container[data-v-e895ccc8]{display:flex;align-items:center;justify-content:center;height:58px;padding:12px 5px 5px}.profile-card__img-container .profile-card__img[data-v-e895ccc8]{width:auto;max-width:35px;height:auto;max-height:35px}.profile-card__title-container[data-v-e895ccc8]{padding:2px 4px 4px}.profile-card__title-container .profile-card__title[data-v-e895ccc8]{display:inline-block;font-size:.875rem;font-weight:600;color:#02346e}.profile-card[data-v-e895ccc8]:focus,.profile-card[data-v-e895ccc8]:hover{box-shadow:0 3px 6px rgba(52,60,88,.4);-webkit-tap-highlight-color:transparent}.profile-card--selected[data-v-e895ccc8]{box-shadow:0 0 0 2px #0467db}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-e895ccc8";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
var script$3 = {
  name: 'SchoolOption',
  components: {
    SelectedIcon: __vue_component__$5
  },
  props: {
    name: {
      type: String,
      required: true
    },
    active: Boolean
  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    class: [_vm.$style.option, (_obj = {}, _obj[_vm.$style.active] = _vm.active, _obj)],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.initial
  }, [_vm._v("\n    " + _vm._s(_vm.name.substr(0, 1)) + "\n  ")]), _c('div', {
    class: _vm.$style.name
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _c('SelectedIcon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.active,
      expression: "active"
    }]
  })], 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-22615383_0", {
    source: ".src-lib-components-option-1S1U{position:relative;display:flex;align-items:center;justify-content:flex-start;width:100%;padding:6px 8px;margin-bottom:8px;background-color:#fff;border:1px solid #c9cccf;border-radius:20px;outline:0;cursor:pointer}.src-lib-components-option-1S1U:focus,.src-lib-components-option-1S1U:hover{box-shadow:0 3px 6px rgba(52,60,88,.4)}.src-lib-components-option-1S1U:nth-child(3n){margin-right:0}.src-lib-components-active-YJHX{border-color:transparent;outline:0;box-shadow:none;box-shadow:0 0 0 3px #438de4}.src-lib-components-active-YJHX:focus,.src-lib-components-active-YJHX:hover{border-color:transparent;outline:0;box-shadow:none;box-shadow:0 0 0 3px #438de4}.src-lib-components-active-YJHX .selected{opacity:1}.src-lib-components-initial-2eOp{display:flex;align-items:center;justify-content:center;width:32px;height:32px;margin-right:8px;font-size:1rem;color:#666e75;text-align:center;background-color:#c9cccf;border-radius:50%}.src-lib-components-name-TeWi{display:flex;justify-content:flex-start;font-size:.875rem;color:#1e2124}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "option": "src-lib-components-option-1S1U",
      "active": "src-lib-components-active-YJHX",
      "initial": "src-lib-components-initial-2eOp",
      "name": "src-lib-components-name-TeWi"
    }
  });
};
/* scoped */


const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

//
var script$2 = {
  name: 'SProfileSelector',
  components: {
    SAutocomplete: __vue_component__$7,
    SProfileCard: __vue_component__$4,
    Icon,
    SchoolOption: __vue_component__$3
  },
  props: {
    profiles: {
      type: Array,
      default: () => []
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    gridProfileDouble: false,
    attendantConsultant: false,
    isMultiProfile: false,
    selectedProfile: null,
    selectedSchool: null,
    cardSize: {},
    isLoading: false,
    vinculatedSchools: false,
    schoolSelectedHelpdesk: null,
    errorState: '',
    errMsg: ''
  }),
  computed: {
    displayDefaultView() {
      return this.isMultiProfile ? this.vinculatedSchools && this.selectedProfile : !this.attendantConsultant;
    },

    displayAttendantConsultantView() {
      return this.isMultiProfile ? this.attendantConsultant && this.selectedProfile !== null : this.attendantConsultant;
    },

    hasError() {
      return this.isMultiProfile ? this.errorState === 'error' : this.errorState === 'error' && this.selectedSchool === null;
    }

  },
  watch: {
    errorMessage: {
      immediate: true,

      handler() {
        this.setErrorState(this.errorMessage);
      }

    },

    selectedProfile() {
      this.$emit('select-profile', this.selectedProfile);

      if (this.selectedProfile.schools.length === 1) {
        [this.selectedSchool] = this.selectedProfile.schools;
      }
    },

    selectedSchool() {
      this.$emit('select-school', this.selectedSchool);
    }

  },

  created() {
    if (this.profiles.length > 0) {
      const DOUBLE = 2;
      this.isMultiProfile = this.profiles.length > 1;

      if (!this.isMultiProfile) {
        [this.selectedProfile] = this.profiles;
        this.validateProfile(this.selectedProfile.id);
      }

      if (this.profiles.length === DOUBLE) {
        this.gridProfileDouble = true;
      }
    }
  },

  methods: {
    setSchoolAutocomplete() {
      this.selectedSchool = this.schoolSelectedHelpdesk;
      this.cleanErrorState();
    },

    isPropertyEmpty(property) {
      return this[property] === null;
    },

    validateProfile(profileId) {
      const hasHelpdesk = [profilesTypes$1.consultant, profilesTypes$1.helpdesk].includes(profileId);
      this.attendantConsultant = this.isMultiProfile ? hasHelpdesk && this.selectedProfile : hasHelpdesk;
      this.vinculatedSchools = this.isMultiProfile ? !hasHelpdesk && this.selectedProfile : !hasHelpdesk;
      this.getSchoolsList();
    },

    getSchoolsList() {
      this.schoolsList = this.selectedProfile.schools;
    },

    selectProfile(profileId) {
      var _this$selectedProfile;

      this.cleanErrorState();
      this.selectedSchool = null;
      this.schoolSelectedHelpdesk = null;

      if (((_this$selectedProfile = this.selectedProfile) === null || _this$selectedProfile === void 0 ? void 0 : _this$selectedProfile.id) === profileId) {
        this.selectedProfile = null;
        this.isLoadingProfile = false;
        return;
      }

      this.selectedProfile = this.profiles.find(profile => profile.id === profileId);
      this.validateProfile(profileId);
    },

    selectSchool(schoolId) {
      var _this$selectedSchool;

      if (((_this$selectedSchool = this.selectedSchool) === null || _this$selectedSchool === void 0 ? void 0 : _this$selectedSchool.id) === schoolId) {
        this.selectedSchool = null;
        return;
      }

      this.selectedSchool = this.selectedProfile.schools.find(school => school.id === schoolId);
      this.cleanErrorState();
    },

    setErrorState(msg) {
      this.errorState = msg ? 'error' : null;
      this.errMsg = msg;

      if (msg) {
        setTimeout(() => {
          this.$refs.errorMessage.scrollIntoView();
        });
      }
    },

    cleanErrorState() {
      this.errorState = null;
      this.errMsg = '';
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.profiles.length > 0 ? _c('div', {
    staticClass: "profile-selector"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm.isMultiProfile ? _c('div', {
    staticClass: "multi-profile-selector"
  }, [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("\n        Escolha um perfil para continuar\n      ")]), _vm.profiles ? _c('div', {
    staticClass: "container-profile",
    class: {
      'grid-profile-double': _vm.gridProfileDouble
    }
  }, _vm._l(_vm.profiles, function (profile) {
    return _c('SProfileCard', {
      key: profile.id,
      staticClass: "profile-selector__item",
      attrs: {
        "id": profile.id,
        "name": profile.name,
        "selected": !!_vm.selectedProfile && _vm.selectedProfile.id === profile.id
      },
      on: {
        "click": function click($event) {
          return _vm.selectProfile(profile.id);
        }
      }
    });
  }), 1) : _vm._e()]) : _vm._e(), _vm.displayDefaultView ? _c('div', {
    staticClass: "search-content"
  }, [_c('h3', {
    staticClass: "sub-title-schools"
  }, [_vm._v("\n        Escolas vinculadas\n      ")]), _c('div', {
    staticClass: "school-list"
  }, _vm._l(_vm.selectedProfile.schools, function (school) {
    return _c('SchoolOption', {
      key: school.id,
      attrs: {
        "active": _vm.selectedSchool && _vm.selectedSchool.id === school.id,
        "name": school.name
      },
      on: {
        "click": function click($event) {
          return _vm.selectSchool(school.id);
        }
      }
    });
  }), 1)]) : _vm._e(), _vm.displayAttendantConsultantView ? _c('div', [_c('h3', {
    staticClass: "sub-title"
  }, [_vm._v("\n        Escolha uma escola para continuar\n      ")]), _c('SAutocomplete', {
    attrs: {
      "options": _vm.schoolsList,
      "prop-display": "name",
      "prop-value": "code",
      "size-dropdown": "large",
      "size-filter": "large",
      "status": _vm.errorState,
      "track-by": "name",
      "width-box-menu": "100%",
      "width-dropdown": "100%"
    },
    on: {
      "select": function select($event) {
        return _vm.setSchoolAutocomplete();
      }
    },
    model: {
      value: _vm.schoolSelectedHelpdesk,
      callback: function callback($$v) {
        _vm.schoolSelectedHelpdesk = $$v;
      },
      expression: "schoolSelectedHelpdesk"
    }
  })], 1) : _vm._e(), _vm.errorState === 'error' ? _c('div', {
    ref: "errorMessage",
    staticClass: "is-error-state",
    attrs: {
      "id": "errorMessage"
    }
  }, [_c('Icon', {
    attrs: {
      "size": "13",
      "type": "alert-circle"
    }
  }), _vm._v("\n      " + _vm._s(_vm.errMsg) + "\n    ")], 1) : _vm._e()]), _c('div', {
    staticClass: "form-footer-multi"
  }, [_vm._t("actions")], 2)]) : _vm._e();
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-20293620_0", {
    source: ".profile-selector__item[data-v-20293620]{margin-right:8px;margin-bottom:16px;margin-left:8px}.content[data-v-20293620]{height:100%}.search-content[data-v-20293620]{height:100%}.school-list[data-v-20293620]{max-height:calc(100% - 230px);overflow-y:auto;padding:8px}@media (min-width:1200px){.school-list[data-v-20293620]{max-height:250px}}.sub-title[data-v-20293620]{margin-bottom:16px;font-size:1.125rem;color:#666e75}.form-footer-multi[data-v-20293620]{display:flex;justify-content:space-between}.sub-title-schools[data-v-20293620]{margin-bottom:16px;font-size:1.125rem;color:#666e75}.container-profile[data-v-20293620]{display:flex;flex-flow:wrap;justify-content:center;margin-right:-8px;margin-bottom:16px;margin-left:-8px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-20293620";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var script$1 = {
  name: 'SMenuProfile',
  components: {
    Icon,
    Modal,
    SButton,
    SProfileSelector: __vue_component__$2
  },
  props: {
    menuProfileOpened: Boolean
  },
  data: () => ({
    profiles: [],
    opened: false,
    isLoading: false,
    schoolsSearchable: false,
    smallSearch: false,
    authServerAPI: Vue.$_menu_env.authServerAPI,
    portalURL: Vue.$_menu_env.portalURL,
    storageAPI: Vue.$_menu_env.storageAPI,
    backgroundProfileImage: `https://static.${portalDomain}/portal/icones/background.svg`,
    backgroundShadowImage: `https://static.${portalDomain}/portal/icones/background.svg`,
    profileTypeImage: '',
    changeProfileVisible: false,
    loadingCSAT: false,
    selectedProfile: null,
    selectedSchool: null,
    profileSelectorError: ''
  }),
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, mapState({
    specificMenu: state => state.menu.specificMenu
  })), mapState('profile', ['currentProfile', 'openProfileModal', 'personalData'])), {}, {
    profileUserName() {
      var _this$personalData$us;

      return ((_this$personalData$us = this.personalData.user) === null || _this$personalData$us === void 0 ? void 0 : _this$personalData$us.name) || '';
    },

    profilePicture() {
      const {
        user
      } = this.personalData;

      if (user !== null && user !== void 0 && user.profilePicture) {
        return `${this.storageAPI}/files/${user.profilePicture}`;
      }

      return '';
    },

    firstUserNameLetter() {
      const {
        user
      } = this.personalData;

      if (user !== null && user !== void 0 && user.name) {
        return user.name.trim().slice(0, 1).toUpperCase();
      }

      return '';
    },

    profilePictureExists() {
      return this.profilePicture !== '';
    }

  }),
  watch: {
    menuProfileOpened(newValue) {
      this.opened = newValue;
    },

    currentProfile() {
      this.profileTypeImage = getProfileTypeIcon(this.currentProfile.profileId);
    }

  },

  async mounted() {
    this.getPersonalData();
    this.getSpecificMenu();
    await this.getProfiles();
    const {
      profiles,
      profileId
    } = this.currentProfile;
    this.opened = this.menuProfileOpened;

    if (profiles) {
      this.changeProfileVisible = profiles.length > 1 || profiles.length === 1 && profiles[0].schools.length > 1;
    }

    this.schoolsSearchable = profileId === profilesTypes$1.hekpdesk || profileId === profilesTypes$1.consultant;
  },

  methods: _objectSpread2(_objectSpread2(_objectSpread2({}, mapActions('menu', ['getSpecificMenu'])), mapActions('profile', ['getProfiles', 'toggleProfileModal', 'getPersonalData'])), {}, {
    logout,

    toggle() {
      this.opened = !this.opened;

      if (this.opened) {
        this.$emit('show-profile', true);
      } else {
        this.$emit('show-profile', null);
      }
    },

    showModal() {
      this.toggleProfileModal(true);
    },

    closeModal() {
      this.$emit('close-modal');
      this.toggleProfileModal(false);
    },

    async chooseProfile() {
      this.isLoading = true;

      try {
        if (this.validateProfileSelected()) {
          const {
            selectedProfile,
            selectedSchool
          } = this;
          const payloadSession = {
            profileId: selectedProfile.id,
            schoolId: selectedSchool.id,
            refreshToken: getRefreshToken()
          };
          const {
            data
          } = await api.post(`${this.authServerAPI}/v2/auth/changeProfile`, payloadSession);
          setAuthCookies(data);
          window.location.assign(`${this.portalURL}/home`);
        }
      } finally {
        this.isLoading = false;
      }
    },

    validateProfileSelected() {
      if (this.selectedProfile === null) {
        this.profileSelectorError = 'Selecione o perfil desejado';
        return false;
      }

      if (this.selectedSchool === null) {
        this.profileSelectorError = 'Selecione a escola desejada';
        return false;
      }

      return true;
    },

    handleSelectProfile(selectedProfile) {
      const OUTER_WIDTH = 1200;
      const OUTER_HEIGHT = 750;
      this.selectedProfile = selectedProfile;
      this.schoolsSearchable = selectedProfile.id === profilesTypes$1.helpdesk || selectedProfile.id === profilesTypes$1.consultant;

      if (this.schoolsSearchable) {
        this.smallSearch = window.outerWidth > OUTER_WIDTH && window.outerHeight < OUTER_HEIGHT;
      }
    },

    handleSelectSchool(selectedSchool) {
      this.selectedSchool = selectedSchool;
    },

    async openCSAT() {
      this.loadingCSAT = true;
      const hiddenFields = {
        account_id: this.personalData.id,
        profile: this.personalData.profileName,
        url: window.location.href
      };

      if ([profilesTypes$1.student, profilesTypes$1.teacher].includes(this.personalData.profileId)) {
        try {
          const {
            data: currentUser
          } = await api.get(`${Vue.$_menu_env.authServerAPI}/v1/users/me`);
          const grades = currentUser.grades.map(grade => grade.name).join();
          hiddenFields.grade = grades;
        } finally {
          this.loadingCSAT = false;
        }
      }

      const typeformPopup = typeform.createPopup({
        formId: 'qLTNvf1Q',
        hiddenFields,
        options: {
          hideScrollbars: true,
          mode: 'popup',
          size: 75
        }
      });
      typeformPopup.open();
    }

  })
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "profile-content",
    on: {
      "click": function click($event) {
        return _vm.toggle();
      }
    }
  }, [_vm.profilePictureExists ? _c('div', [_c('img', {
    staticClass: "profile-image",
    attrs: {
      "src": _vm.profilePicture
    }
  })]) : _c('div', {
    staticClass: "profile-image"
  }, [_vm._v("\n      " + _vm._s(_vm.firstUserNameLetter) + "\n    ")]), _c('div', {
    staticClass: "profile-infos"
  }, [_c('div', {
    staticClass: "profile-type"
  }, [_vm._v("\n        " + _vm._s(_vm.currentProfile.profileName) + "\n        "), _c('Icon', {
    staticClass: "icon-profile-name",
    attrs: {
      "size": "16px",
      "type": "chevron-down"
    }
  })], 1), _c('div', {
    staticClass: "info-group"
  }, [_c('strong', {
    staticClass: "profile-user-name"
  }, [_vm._v("\n          " + _vm._s(_vm.profileUserName) + "\n        ")]), _c('div', {
    staticClass: "profile-school-name"
  }, [_vm._v("\n          " + _vm._s(_vm.currentProfile.schoolName) + "\n        ")])])]), _c('div', {
    staticClass: "menu-profile",
    class: {
      active: _vm.opened
    }
  }, [_vm.profileUserName && _vm.currentProfile.schoolName ? _c('div', {
    staticClass: "profile-details"
  }, [_c('div', {
    staticClass: "profile-type"
  }, [_vm._v("\n          " + _vm._s(_vm.currentProfile.profileName) + "\n        ")]), _c('div', {
    staticClass: "profile-info"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    staticClass: "img-profile",
    attrs: {
      "alt": "",
      "src": _vm.profileTypeImage
    }
  }), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": _vm.backgroundShadowImage
    }
  })]), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v("\n              " + _vm._s(_vm.profileUserName) + "\n            ")]), _c('div', {
    staticClass: "school-name"
  }, [_vm._v("\n              " + _vm._s(_vm.currentProfile.schoolName) + "\n            ")])])])]) : _vm._e(), _vm.specificMenu.length > 0 ? _c('ul', _vm._l(_vm.specificMenu, function (menu) {
    return _c('li', {
      key: menu.id
    }, [menu.displayMode === 'newTab' ? _c('a', {
      staticClass: "submenu-link",
      attrs: {
        "href": menu.link,
        "rel": "noopener noreferrer",
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(menu.name) + "\n          ")]) : _c('a', {
      staticClass: "submenu-link",
      attrs: {
        "href": menu.link
      }
    }, [_vm._v("\n            " + _vm._s(menu.name) + "\n          ")])]);
  }), 0) : _vm._e(), _c('ul', [_vm.changeProfileVisible ? _c('li', [_c('button', {
    staticClass: "s-menu-link-primary",
    on: {
      "click": function click($event) {
        return _vm.showModal();
      }
    }
  }, [_c('Icon', {
    staticClass: "s-menu-link-primary-icon",
    attrs: {
      "size": "16px",
      "type": "repeat"
    }
  }), _vm._v("\n            Trocar / Adicionar acesso\n          ")], 1)]) : _c('li', [_c('a', {
    staticClass: "s-menu-link-primary",
    attrs: {
      "href": _vm.portalURL + "/ativar-acesso"
    }
  }, [_c('Icon', {
    staticClass: "s-menu-link-primary-icon",
    attrs: {
      "size": "16px",
      "type": "repeat"
    }
  }), _vm._v("\n            Adicionar Acesso\n          ")], 1)]), _c('li', [_c('a', {
    staticClass: "submenu-link",
    attrs: {
      "href": _vm.portalURL + "/meus-dados"
    }
  }, [_c('Icon', {
    staticClass: "s-menu-link-primary-icon",
    attrs: {
      "size": "16px",
      "type": "user"
    }
  }), _vm._v("\n            Meus Dados\n          ")], 1)]), _c('li', [_c('button', {
    staticClass: "submenu-link",
    on: {
      "click": function click($event) {
        return _vm.openCSAT();
      }
    }
  }, [_c('Icon', {
    staticClass: "s-menu-link-primary-icon",
    attrs: {
      "size": "16px",
      "type": "star"
    }
  }), _vm._v("\n            Avalie o portal\n          ")], 1)]), _c('li', [_c('a', {
    staticClass: "submenu-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logout();
      }
    }
  }, [_c('Icon', {
    staticClass: "s-menu-link-primary-icon",
    attrs: {
      "size": "16px",
      "type": "log-in"
    }
  }), _vm._v("\n            Sair\n          ")], 1)])])])]), _vm.openProfileModal ? _c('Modal', {
    attrs: {
      "width": "548px"
    },
    on: {
      "close": function close($event) {
        return _vm.closeModal();
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('h2', {
          staticClass: "modal-title"
        }, [_vm._v("\n        Trocar / Adicionar acesso\n      ")])];
      },
      proxy: true
    }], null, false, 3198754597)
  }, [_c('form', {
    class: {
      searchable: _vm.schoolsSearchable,
      'small-search': _vm.smallSearch
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.chooseProfile();
      }
    }
  }, [_c('SProfileSelector', {
    attrs: {
      "error-message": _vm.profileSelectorError,
      "profiles": _vm.currentProfile.profiles
    },
    on: {
      "select-profile": function selectProfile($event) {
        return _vm.handleSelectProfile($event);
      },
      "select-school": function selectSchool($event) {
        return _vm.handleSelectSchool($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('SButton', {
          attrs: {
            "href": _vm.portalURL + "/ativar-acesso",
            "icon-left": "plus",
            "size": "large",
            "variation": "tertiary",
            "width": "183px"
          }
        }, [_vm._v("\n            Novo acesso\n          ")]), _c('SButton', {
          attrs: {
            "loading": _vm.isLoading,
            "size": "large",
            "type": "submit",
            "width": "145px"
          }
        }, [_vm._v("\n            Trocar\n          ")])];
      },
      proxy: true
    }], null, false, 3190906562)
  })], 1)]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-1a2d06c8_0", {
    source: "[data-v-1a2d06c8] .sas-modal__container{height:100%;border-radius:0!important}[data-v-1a2d06c8] .sas-modal__container .profile-selector-body{display:flex;flex-flow:column;justify-content:space-between;height:100%}@media (min-width:1200px){[data-v-1a2d06c8] .sas-modal__container{height:auto;border-radius:10px!important}[data-v-1a2d06c8] .sas-modal__container .form-footer-multi{margin-top:20px}}[data-v-1a2d06c8] .sas-modal__body{height:calc(100% - 50px)}[data-v-1a2d06c8] .sas-modal__body>div{height:100%}[data-v-1a2d06c8] .s-menu-link-primary-icon{display:block;margin-right:8px}.modal-title[data-v-1a2d06c8]{margin-bottom:0;font-size:1.375rem}@media (min-width:1200px){.modal-title[data-v-1a2d06c8]{font-size:1.75rem}}.profile-content[data-v-1a2d06c8]{display:flex;width:242px;padding:8px;font-size:.875rem;cursor:pointer}.small-search[data-v-1a2d06c8] .sas-dropdown-menu{max-height:190px}.profile-infos[data-v-1a2d06c8]{display:flex;flex-direction:column;width:100%}.profile-infos .icon-profile-name[data-v-1a2d06c8]{width:14px;height:14px}.profile-infos .profile-type[data-v-1a2d06c8]{display:flex;align-items:center;font-size:.625rem;font-weight:700;line-height:1;color:#0467db;text-transform:uppercase}.profile-infos .info-group[data-v-1a2d06c8]{display:flex;flex-direction:column}@media (min-width:1200px){.profile-infos .info-group[data-v-1a2d06c8]{flex-direction:row;flex-direction:column;width:160px}}.profile-infos .profile-school-name[data-v-1a2d06c8],.profile-infos .profile-user-name[data-v-1a2d06c8]{margin-right:8px;overflow:hidden;font-size:.75rem;color:#1e2124;text-overflow:ellipsis;white-space:nowrap}@media (min-width:1200px){.profile-infos .profile-school-name[data-v-1a2d06c8],.profile-infos .profile-user-name[data-v-1a2d06c8]{max-width:138px;margin-right:0}}.profile-image[data-v-1a2d06c8]{box-sizing:border-box;display:flex;align-items:center;justify-content:center;width:25px;min-width:25px;height:25px;min-height:25px;margin-right:8px;font-size:1.375rem;color:#0467db;background:#fff;border:none;border-radius:50%;box-shadow:0 1px 4px rgba(0,0,0,.25)}@media (min-width:1200px){.profile-image[data-v-1a2d06c8]{width:50px;min-width:50px;height:50px;min-height:50px;margin:0 8px 0 0;font-size:1.375rem;font-size:20px;background:#fff;border:2px solid #0467db;border-radius:50%;box-shadow:none}}.user-name[data-v-1a2d06c8]{font-weight:800}.profile-details[data-v-1a2d06c8]{padding:8px;border-bottom:1px solid #c9cccf}.profile-details .profile-type[data-v-1a2d06c8]{margin-bottom:8px;font-size:.75rem;color:#0467db;text-transform:uppercase}.profile-details .user-info[data-v-1a2d06c8]{padding-left:7px;font-size:.75rem}.profile-info[data-v-1a2d06c8]{display:flex}.profile-info .img-profile[data-v-1a2d06c8]{position:relative;z-index:1;width:40px;height:40px}.profile-info .shadow[data-v-1a2d06c8]{position:absolute;right:0;bottom:-16px;width:46px;height:46px}.image-info[data-v-1a2d06c8]{position:relative;justify-content:center;width:46px;height:46px;border:1px solid #c9cccf;border-radius:5px;box-shadow:0 .5px 1px rgba(52,60,88,.4)}.menu-profile[data-v-1a2d06c8]{position:absolute;top:70px;left:100%;z-index:1;width:100%;height:100%;overflow:hidden;background-color:#fff;border-radius:0 0 8px 8px;transition:left .3s ease .2s}@media (min-width:1200px){.menu-profile[data-v-1a2d06c8]{top:68px;right:0;left:auto;display:none;width:250px;height:auto;box-shadow:0 2px 2px rgba(0,0,0,.034),0 6px 5px rgba(0,0,0,.048),0 12px 10px rgba(0,0,0,.06),0 22px 17px rgba(0,0,0,.072),0 41px 33px rgba(0,0,0,.086)}}.menu-profile.active[data-v-1a2d06c8]{right:0;left:auto;display:block}.menu-profile li[data-v-1a2d06c8]{border-bottom:1px solid #c9cccf}@media (min-width:1200px){.menu-profile li[data-v-1a2d06c8]{border-bottom:none}.menu-profile li[data-v-1a2d06c8]:not(:last-child){border-bottom:none}}.menu-profile li[data-v-1a2d06c8] .sas-button.--tertiary{display:flex;width:100%;height:auto;padding:16px!important;border-radius:0}.submenu-link[data-v-1a2d06c8]{display:flex;align-items:center;padding:16px;line-height:1;width:100%;appearance:none;border:0;background-color:#fff;cursor:pointer}.submenu-link[data-v-1a2d06c8]:focus{border-color:transparent;outline:0;box-shadow:none;box-shadow:0 0 0 3px #438de4}.submenu-link[data-v-1a2d06c8]:hover{background-color:rgba(0,0,0,.1)}.s-menu-link-primary[data-v-1a2d06c8]{display:flex;align-items:center;justify-content:center;width:100%;padding:16px;color:#0467db;cursor:pointer;background-color:transparent;border:0;border-radius:0}.s-menu-link-primary[data-v-1a2d06c8]:focus{border-color:transparent;outline:0;box-shadow:none;box-shadow:0 0 0 3px #438de4}.s-menu-link-primary[data-v-1a2d06c8]:hover{background-color:rgba(0,0,0,.1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = "data-v-1a2d06c8";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var script = {
  name: 'SMenu',
  components: {
    ToggleMenu: __vue_component__$6,
    Icon,
    SButton,
    SMenuProfile: __vue_component__$1
  },
  data: () => ({
    sasLogo: 'https://cdn.arcotech.io/sas/images/sas_plataforma_de_educacao.svg',
    menuActive: null,
    menuResponsive: false,
    navbarNav: {},
    portalURL: Vue.$_menu_env.portalURL,
    publicFilesURL: Vue.$_menu_env.publicFilesURL
  }),
  computed: _objectSpread2(_objectSpread2({}, mapState({
    menus: state => state.menu.menus,
    currentProfile: state => state.profile.currentProfile,
    hasLoadedPersonalData: state => !!state.profile.personalData.id,
    customLogo: state => {
      var _state$profile$person;

      return (_state$profile$person = state.profile.personalData) === null || _state$profile$person === void 0 ? void 0 : _state$profile$person.logoUrl;
    }
  })), {}, {
    enableNext() {
      const {
        offsetWidth,
        scrollLeft,
        scrollWidth
      } = this.navbarNav;
      return offsetWidth + scrollLeft < scrollWidth;
    },

    enablePrevious() {
      return this.navbarNav.scrollLeft > 0;
    }

  }),
  watch: {
    menus() {
      this.$nextTick(this.updateNavbarControls);
    }

  },

  created() {
    this.getMenus();
    typeform.install({
      onReady: () => {
        this.setTypeformReady(true);
      }
    });
  },

  methods: _objectSpread2(_objectSpread2(_objectSpread2({}, mapMutations('typeform', ['setTypeformReady'])), mapActions('menu', ['getMenus'])), {}, {
    toggleMenu(value) {
      if (!value) {
        this.menuActive = null;
      }

      this.menuResponsive = value;
    },

    showProfile(value) {
      this.menuActive = value;
    },

    getImageMenu(item) {
      var _item$iconPath;

      return (_item$iconPath = item.iconPath) !== null && _item$iconPath !== void 0 && _item$iconPath.trim() ? `${this.publicFilesURL}/${item.iconPath}` : `https://public.${portalDomain}/img/img-default-menu.svg`;
    },

    activeMenu(item) {
      if (item.type !== 'group') {
        return;
      }

      if (this.menuActive === item.id) {
        this.menuActive = null;
        return;
      }

      this.$refs.navbarNav.$el.scrollTop = 0;
      this.menuActive = item.id;
    },

    closeSubmenus() {
      this.menuActive = null;
    },

    moveMenu(value) {
      const navbarNav = this.$refs.navbarNav.$el;
      const {
        scrollLeft,
        offsetWidth
      } = navbarNav;
      const averageItemWidth = offsetWidth / this.menus.length;
      navbarNav.scrollLeft = value ? scrollLeft + averageItemWidth : scrollLeft - averageItemWidth;
      this.updateNavbarControls();
    },

    getIntegrationLink(menuItem) {
      const baseLink = menuItem.link;
      const queryMark = baseLink.includes('?') ? '&' : '?';
      const sessionToken = getAuthSession();
      return menuItem.isExternalIntegration ? `${baseLink}${queryMark}token=${sessionToken}` : baseLink;
    },

    updateNavbarControls() {
      const navbarNav = this.$refs.navbarNav.$el;
      const {
        scrollLeft,
        offsetWidth,
        scrollWidth
      } = navbarNav;
      this.navbarNav = {
        scrollLeft,
        offsetWidth,
        scrollWidth
      };
    }

  })
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _obj, _obj$1;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('nav', {
    class: _vm.$style.contentMenu
  }, [_c('transition', {
    attrs: {
      "enter-active-class": _vm.$style.fadeEnterActive,
      "enter-class": _vm.$style.fadeEnter,
      "leave-active-class": _vm.$style.fadeLeaveActive,
      "leave-to-class": _vm.$style.fadeleaveTo
    }
  }, [_vm.hasLoadedPersonalData ? _c('a', {
    class: _vm.$style.mainLogo,
    attrs: {
      "href": _vm.portalURL
    }
  }, [_c('img', {
    attrs: {
      "alt": "SAS Plataforma de Educação",
      "src": _vm.customLogo || _vm.sasLogo
    }
  })]) : _vm._e()]), _c('transition', {
    attrs: {
      "enter-active-class": _vm.$style.fadeEnterActive,
      "enter-class": _vm.$style.fadeEnter,
      "leave-active-class": _vm.$style.fadeLeaveActive,
      "leave-to-class": _vm.$style.fadeleaveTo
    }
  }, [_vm.customLogo ? _c('div', {
    class: _vm.$style.portalsasLogoExtra
  }, [_c('img', {
    attrs: {
      "alt": "SAS Plataforma de Educação",
      "src": _vm.sasLogo
    }
  })]) : _vm._e()]), _c('div', {
    class: [_vm.$style.menuItems, (_obj = {}, _obj[_vm.$style.menuItemsOpen] = _vm.menuResponsive, _obj[_vm.$style.hasCustomLogo] = !!_vm.customLogo, _obj)]
  }, [_c('transition-group', {
    ref: "navbarNav",
    class: [_vm.$style.items, (_obj$1 = {}, _obj$1[_vm.$style.itemsHasOpen] = _vm.menuActive !== null, _obj$1)],
    attrs: {
      "enter-active-class": _vm.$style.fadeEnterActive,
      "enter-class": _vm.$style.fadeEnter,
      "leave-active-class": _vm.$style.fadeLeaveActive,
      "leave-to-class": _vm.$style.fadeleaveTo,
      "tag": "ul"
    }
  }, _vm._l(_vm.menus, function (item, index) {
    var _obj;

    return _c('li', {
      key: item.id,
      class: [_vm.$style.itemMenu, (_obj = {}, _obj[_vm.$style.itemMenuActive] = _vm.menuActive === item.id, _obj)],
      style: {
        transitionDelay: index + "00ms"
      }
    }, [item.type === 'group' ? _c('a', {
      class: _vm.$style.link,
      attrs: {
        "href": "#"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.activeMenu(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _c('span', {
      class: _vm.$style.iconMenuGroup
    }, [_vm._v("›")])]) : _c('a', {
      class: _vm.$style.link,
      attrs: {
        "href": _vm.getIntegrationLink(item),
        "target": item.displayMode === 'newTab' ? '_blank' : '_self'
      },
      on: {
        "click": function click($event) {
          return _vm.activeMenu(item);
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]), _c('div', {
      class: _vm.$style.contentSubMenu
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.menuActive === item.id,
        expression: "menuActive === item.id"
      }]
    }, [_c('h2', {
      class: _vm.$style.titleSubMenu
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")]), _c('ul', {
      class: _vm.$style.subMenus
    }, _vm._l(item.subItems, function (subItem) {
      return _c('li', {
        key: subItem.id,
        class: _vm.$style.subMenuItem
      }, [_c('a', {
        class: _vm.$style.linkSubMenu,
        attrs: {
          "href": _vm.getIntegrationLink(subItem),
          "target": subItem.displayMode === 'newTab' ? '_blank' : ''
        }
      }, [_c('img', {
        class: _vm.$style.imageMenu,
        attrs: {
          "src": _vm.getImageMenu(subItem)
        }
      }), _c('div', {
        class: _vm.$style.subMenuInfos
      }, [_c('span', {
        class: _vm.$style.subMenuTitle
      }, [_vm._v("\n                      " + _vm._s(subItem.name) + "\n                    ")]), _c('span', {
        class: _vm.$style.subMenuDescription
      }, [_vm._v("\n                      " + _vm._s(subItem.description) + "\n                    ")])])])]);
    }), 0), _c('SButton', {
      class: _vm.$style.iconSubmenuClose,
      attrs: {
        "icon": "x",
        "tabindex": "0",
        "variation": "tertiary"
      },
      on: {
        "click": function click($event) {
          return _vm.closeSubmenus();
        },
        "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          return _vm.closeSubmenus();
        }
      }
    })], 1)])]);
  }), 0), _c('div', {
    class: _vm.$style.fadingContentEffect
  }), _c('div', {
    class: _vm.$style.profile
  }, [_vm.enablePrevious || _vm.enableNext ? _c('div', {
    class: _vm.$style.navItems
  }, [_c('SButton', {
    class: _vm.$style.navMenuItems,
    attrs: {
      "disabled": !_vm.enablePrevious,
      "icon": "chevron-left",
      "variation": "tertiary"
    },
    on: {
      "click": function click($event) {
        return _vm.moveMenu(false);
      }
    }
  }), _c('SButton', {
    class: _vm.$style.navMenuItems,
    attrs: {
      "disabled": !_vm.enableNext,
      "icon": "chevron-right",
      "variation": "tertiary"
    },
    on: {
      "click": function click($event) {
        return _vm.moveMenu(true);
      }
    }
  })], 1) : _vm._e(), _c('SMenuProfile', {
    attrs: {
      "menu-profile-opened": _vm.menuActive === -1
    },
    on: {
      "close-modal": function closeModal($event) {
        _vm.menuActive = null;
      },
      "show-profile": function showProfile($event) {
        return _vm.showProfile($event);
      }
    }
  }), _c('div', {
    class: _vm.$style.menuInfoRight
  }, [_c('div', {
    class: _vm.$style.menuResponsive,
    style: {
      'justify-content': _vm.menuActive !== null ? 'space-between' : 'flex-end'
    }
  }, [typeof _vm.menuActive === 'number' && _vm.menuResponsive ? _c('button', {
    class: _vm.$style.iconMenuArrowLeft,
    on: {
      "click": function click($event) {
        return _vm.closeSubmenus();
      }
    }
  }, [_c('Icon', {
    attrs: {
      "size": "24px",
      "type": "arrow-left"
    }
  })], 1) : _vm._e(), _c('ToggleMenu', {
    on: {
      "toggle": function toggle($event) {
        return _vm.toggleMenu($event);
      }
    }
  })], 1)])], 1)], 1)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-6b2a6456_0", {
    source: ".src-lib-components-contentMenu-9lB9{position:fixed;top:0;left:0;z-index:1030;box-sizing:border-box;display:flex;flex-direction:row;width:100%;height:71px;padding-right:16px;padding-left:16px;background:#fff;border-top:3px solid #003064;border-bottom:1px solid #c9cccf}@media (min-width:1200px){.src-lib-components-contentMenu-9lB9{flex-direction:row;align-items:center;height:71px}}.src-lib-components-mainLogo-6rSu,.src-lib-components-portalsasLogoExtra-34yR{display:flex;align-items:center;justify-content:center;margin-right:8px}.src-lib-components-mainLogo-6rSu img,.src-lib-components-portalsasLogoExtra-34yR img{width:73px}.src-lib-components-portalsasLogoExtra-34yR{margin:auto;order:6;padding-right:45px}@media (min-width:1200px){.src-lib-components-portalsasLogoExtra-34yR{margin:0;padding-right:0}}.src-lib-components-titleSubMenu-1WZ3{margin:16px;font-size:1.5rem;color:#1e2124}.src-lib-components-contentSubMenu-yw-L{position:absolute;top:0;right:-100%;z-index:110;width:100%;height:100%;max-height:100%;padding-bottom:20px;background-color:#fff;opacity:0;transition:right .3s ease}@media (min-width:1200px){.src-lib-components-contentSubMenu-yw-L{position:absolute;top:71px;left:0;z-index:-1;display:flex;flex-direction:column;height:auto;max-height:0;padding-right:16px;padding-bottom:8px;padding-left:80px;overflow:hidden;background:#fff;box-shadow:none;transition:visibility .5s ease 0s,max-height .5s ease 0s,box-shadow .3s ease 0s}}.src-lib-components-subMenus-3Zu2{display:flex;flex-flow:wrap;width:100%;padding-left:0;margin:0}@media (min-width:1200px){.src-lib-components-subMenus-3Zu2{flex-direction:row;padding-left:16px}}.src-lib-components-subMenuItem-q76U{display:flex;justify-content:flex-start;width:100%;border-top:1px solid #c9cccf}@media (min-width:1200px){.src-lib-components-subMenuItem-q76U{width:33.3333333333%;border:none}}.src-lib-components-iconSubmenuClose-7ISL{display:none;width:24px;height:24px}@media (min-width:1200px){.src-lib-components-iconSubmenuClose-7ISL{position:absolute;top:10px;right:10px;display:flex}}.src-lib-components-linkSubMenu-DIQQ{width:100%;padding:8px}.src-lib-components-linkSubMenu-DIQQ:hover{background:#f7f7f7;border-radius:0}@media (min-width:1200px){.src-lib-components-linkSubMenu-DIQQ:hover{border-radius:10px}}.src-lib-components-subMenuTitle-2bku{color:#0467db!important}.src-lib-components-menuItems-13jX{position:fixed;top:71px;right:-95%;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;height:100%;box-shadow:0 4px 4px rgba(0,0,0,.25);transition:right .3s linear 0s}@media (min-width:1200px){.src-lib-components-menuItems-13jX{position:relative;top:0;right:0;flex-direction:row;align-items:flex-end;justify-content:space-between;width:calc(100% - 81px);box-shadow:none}}.src-lib-components-items-_AYS{position:relative;width:100%;height:100%;padding-left:0;margin:0;overflow:hidden;scroll-behavior:smooth}@media (min-width:1200px){.src-lib-components-items-_AYS{display:flex;align-items:center;order:unset;order:2;width:100%}}.src-lib-components-linkSubMenu-DIQQ{display:flex;justify-content:flex-start;width:100%;padding:8px}.src-lib-components-imageMenu-1Baq{display:none}@media (min-width:1200px){.src-lib-components-imageMenu-1Baq{display:flex;width:72px;height:72px;margin-right:24px}}.src-lib-components-subMenuInfos-3pVK{display:flex;flex-direction:column;justify-content:center}.src-lib-components-subMenuTitle-2bku{font-size:1rem;color:#1e2124}.src-lib-components-subMenuDescription-1eTn{font-size:.875rem;color:#666e75}.src-lib-components-link-1_Pf{display:flex;width:100%;padding:16px 8px;font-size:.875rem;font-weight:500;color:#003064;text-decoration:none;letter-spacing:.4px;white-space:nowrap;cursor:pointer;border-bottom:1px solid transparent;transition:opacity .3s ease}.src-lib-components-link-1_Pf:focus,.src-lib-components-link-1_Pf:hover{border-bottom-color:#003064;outline:0}@media (min-width:1200px){.src-lib-components-link-1_Pf{align-items:center;justify-content:center;padding:0 8px}}.src-lib-components-iconMenuGroup-29kv{display:flex;align-items:center;justify-content:center;width:20px;height:20px}@media (min-width:1200px){.src-lib-components-iconMenuGroup-29kv{transform:rotate(90deg)}}.src-lib-components-itemMenu-1dec{display:flex;border-bottom:1px solid #c9cccf}@media (min-width:1200px){.src-lib-components-itemMenu-1dec{height:100%;margin-right:8px;border-bottom:none}}.src-lib-components-menuItemsOpen-aaXx{right:0;justify-content:flex-start;background-color:#fff}@media (min-width:1200px){.src-lib-components-menuItemsOpen-aaXx{position:relative;flex-direction:row;flex-direction:column;justify-content:space-between;width:100%;box-shadow:none}}.src-lib-components-menuItemsOpen-aaXx .src-lib-components-items-_AYS{display:flex;flex-direction:column;order:2}@media (min-width:1200px){.src-lib-components-menuItemsOpen-aaXx .src-lib-components-items-_AYS{flex-direction:row;order:unset}}.src-lib-components-menuItemsOpen-aaXx .src-lib-components-itemsHasOpen-33l4{overflow:hidden}.src-lib-components-menuItemsOpen-aaXx .src-lib-components-itemsHasOpen-33l4 .src-lib-components-link-1_Pf{opacity:0}.src-lib-components-menuItemsOpen-aaXx .src-lib-components-menuInfoLeft-34PG{display:none}@media (min-width:1200px){.src-lib-components-menuItemsOpen-aaXx .src-lib-components-menuInfoLeft-34PG{display:flex;height:48px}}.src-lib-components-itemMenuActive-2uVO .src-lib-components-contentSubMenu-yw-L{right:0;overflow-x:hidden;overflow-y:auto;opacity:1}@media (min-width:1200px){.src-lib-components-itemMenuActive-2uVO .src-lib-components-contentSubMenu-yw-L{position:fixed;z-index:999;max-height:500px;padding-left:0;padding-left:80px;box-shadow:0 4px 4px rgba(0,0,0,.25);transition:visibility .5s ease 0s,max-height .5s ease 0s,box-shadow .3s ease 0s}}.src-lib-components-itemMenuActive-2uVO .src-lib-components-subMenus-3Zu2,.src-lib-components-itemMenuActive-2uVO .src-lib-components-titleSubMenu-1WZ3{opacity:1}@media (min-width:1200px){.src-lib-components-itemMenuActive-2uVO .src-lib-components-subMenus-3Zu2,.src-lib-components-itemMenuActive-2uVO .src-lib-components-titleSubMenu-1WZ3{display:flex}}.src-lib-components-menuInfoRight-1I8n{order:1;width:100%}@media (min-width:1200px){.src-lib-components-menuInfoRight-1I8n{display:none}}.src-lib-components-menuInfoLeft-34PG{display:flex;flex-direction:row;align-items:center}@media (min-width:1200px){.src-lib-components-menuInfoLeft-34PG{order:1;min-height:48px}}.src-lib-components-menuResponsive-3GpT{display:flex;align-items:center;justify-content:flex-end;width:100%;border:none}.src-lib-components-navItems-2SCJ{display:none}@media (min-width:1200px){.src-lib-components-navItems-2SCJ{position:absolute;position:relative;bottom:0;left:-112px;left:0;display:flex;align-items:center;order:1;order:0;margin:8px 16px;margin-right:8px;margin-left:0;background:#fff}}.src-lib-components-navMenuItems-1lOF{width:36px;height:36px;color:#1e2124;cursor:pointer;background-color:#f7f7f7;border:0;border-radius:8px;transition:all .2s ease-in-out}.src-lib-components-navMenuItems-1lOF:disabled{background-color:transparent}.src-lib-components-navMenuItems-1lOF:not(:disabled):hover{background:#c9cccf}.src-lib-components-navMenuItems-1lOF:focus{border-color:transparent;outline:0;box-shadow:none;box-shadow:0 0 0 3px #438de4}.src-lib-components-navMenuItems-1lOF:not(:last-child){margin-right:8px}@media (min-width:1200px){.src-lib-components-navMenuItems-1lOF{position:relative}}.src-lib-components-fadeEnter-2BeG,.src-lib-components-fadeleaveTo-2SBc{opacity:0}.src-lib-components-fadeEnterActive-3ocA,.src-lib-components-fadeLeaveActive-3dsj{transition:opacity .5s}.src-lib-components-fadingContentEffect-U7-s{position:absolute;right:0;bottom:0;display:none;order:2;height:100%}.src-lib-components-fadingContentEffect-U7-s::after{display:block;width:24px;height:100%;content:\"\";background:linear-gradient(90deg,transparent,#fff)}@media (min-width:1200px){.src-lib-components-fadingContentEffect-U7-s{position:relative;display:block;width:1px}.src-lib-components-fadingContentEffect-U7-s::after{position:absolute;left:-23px}}.src-lib-components-profile-3FVo{display:flex;flex-direction:column;align-items:center;justify-content:space-between;order:0}@media (min-width:1200px){.src-lib-components-profile-3FVo{position:relative;flex-direction:column;flex-direction:row;align-items:center;order:1;order:2;height:100%;padding-left:0;padding-left:8px;margin-top:-30px;margin-top:0}}.src-lib-components-iconMenuArrowLeft-2Xoy{position:fixed;top:18px;right:60px;padding:8px 16px;cursor:pointer;background-color:transparent;border:0;appearance:none}.src-lib-components-hasCustomLogo-2Jjl{width:calc(100% - 156px)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "contentMenu": "src-lib-components-contentMenu-9lB9",
      "mainLogo": "src-lib-components-mainLogo-6rSu",
      "portalsasLogoExtra": "src-lib-components-portalsasLogoExtra-34yR",
      "titleSubMenu": "src-lib-components-titleSubMenu-1WZ3",
      "contentSubMenu": "src-lib-components-contentSubMenu-yw-L",
      "subMenus": "src-lib-components-subMenus-3Zu2",
      "subMenuItem": "src-lib-components-subMenuItem-q76U",
      "iconSubmenuClose": "src-lib-components-iconSubmenuClose-7ISL",
      "linkSubMenu": "src-lib-components-linkSubMenu-DIQQ",
      "subMenuTitle": "src-lib-components-subMenuTitle-2bku",
      "menuItems": "src-lib-components-menuItems-13jX",
      "items": "src-lib-components-items-_AYS",
      "imageMenu": "src-lib-components-imageMenu-1Baq",
      "subMenuInfos": "src-lib-components-subMenuInfos-3pVK",
      "subMenuDescription": "src-lib-components-subMenuDescription-1eTn",
      "link": "src-lib-components-link-1_Pf",
      "iconMenuGroup": "src-lib-components-iconMenuGroup-29kv",
      "itemMenu": "src-lib-components-itemMenu-1dec",
      "menuItemsOpen": "src-lib-components-menuItemsOpen-aaXx",
      "itemsHasOpen": "src-lib-components-itemsHasOpen-33l4",
      "menuInfoLeft": "src-lib-components-menuInfoLeft-34PG",
      "itemMenuActive": "src-lib-components-itemMenuActive-2uVO",
      "menuInfoRight": "src-lib-components-menuInfoRight-1I8n",
      "menuResponsive": "src-lib-components-menuResponsive-3GpT",
      "navItems": "src-lib-components-navItems-2SCJ",
      "navMenuItems": "src-lib-components-navMenuItems-1lOF",
      "fadeEnter": "src-lib-components-fadeEnter-2BeG",
      "fadeleaveTo": "src-lib-components-fadeleaveTo-2SBc",
      "fadeEnterActive": "src-lib-components-fadeEnterActive-3ocA",
      "fadeLeaveActive": "src-lib-components-fadeLeaveActive-3dsj",
      "fadingContentEffect": "src-lib-components-fadingContentEffect-U7-s",
      "profile": "src-lib-components-profile-3FVo",
      "iconMenuArrowLeft": "src-lib-components-iconMenuArrowLeft-2Xoy",
      "hasCustomLogo": "src-lib-components-hasCustomLogo-2Jjl"
    }
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

const install = function installMainMenuVue(Vue, {
  store,
  env = 'development'
}) {
  /* eslint-disable no-param-reassign */
  Vue.$_menu_env = urls[env];
  setCookieDomain(env);
  setupAuth({
    portalURL: Vue.$_menu_env.portalURL,
    authServerAPI: Vue.$_menu_env.authServerAPI
  });
  store.registerModule('menu', menuModule);
  store.registerModule('profile', profileModule); // eslint-disable-next-line no-underscore-dangle

  if (!hasOwnProperty(store._modulesNamespaceMap, 'typeform/')) {
    store.registerModule('typeform', typeformModule);
  }

  if (install.installed) {
    return;
  }

  install.installed = true;
}; // Create module definition for Vue.use()


const plugin = {
  install
}; // To auto-install on non-es builds, when vue is found

{
  let GlobalVue = null;

  if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
  } else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
  }

  if (GlobalVue) {
    GlobalVue.use(plugin);
  }
} // Default export is library as a whole, registered via Vue.use()

export { __vue_component__$7 as SAutocomplete, __vue_component__ as SMenu, __vue_component__$1 as SMenuProfile, __vue_component__$4 as SProfileCard, __vue_component__$2 as SProfileSelector, __vue_component__$6 as ToggleMenu, plugin as default };
